/* eslint-disable react-hooks/exhaustive-deps */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useEffect, useRef, useState } from "react"
import { Button } from "react-bootstrap"
import * as wjInput from "@grapecity/wijmo.react.input"
import { Popup } from "@grapecity/wijmo.input"
import * as toastify from "react-toastify"
import { FlexGrid, Column } from "@grapecity/wijmo.grid"
import { faSave, faTasks } from "@fortawesome/free-solid-svg-icons"
import { showWarningToast } from "../CustomToast"
// import { useDispatch } from "react-redux"
import { TWijmoListBox } from "../../type/wijmoComponents"
// import { AppDispatch } from ".."
import flexGridHelper from "../../ts/helpers/flexGridHelper"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../globalStore/rootreducer"
import SyainGridLayoutService from "../../service/master/syainGridLayout/SyainGridLayoutService"
import { AppDispatch } from "../.."
import { 画面ロック解除, 画面ロック開始 } from "../../globalStore/progressStore"

/**
 * 列表示設定ボタン
 * 設定する場合、setDefaultLayoutをgridのinitialize時に実行すること
 * @param param0
 * @returns
 */
export const GridRowPickupButton = ({
  flexGrid,
  thisGridLayoutKey,
  gridDefaultLayout,
  gridName,
  gridLayoutPath,
  thisPageSizeLayoutKey,
  ...any
}: {
  flexGrid: FlexGrid | undefined
  thisGridLayoutKey: string
  gridDefaultLayout: string
  gridName?: string
  gridLayoutPath?: string
  thisPageSizeLayoutKey?: string
}) => {
  const popoverButton = useRef(null)
  const [columnPicker, setColumnPicker] = useState<TWijmoListBox>()
  const [layoutPopup, setLayoutPopup] = useState<Popup>()
  const [flexGridInitialized, setFlexGridInitialized] = useState<boolean>(false)
  const { LoginUserInfo: userInfo } = useSelector(
    (state: RootState) => state.user
  )
  const dispatch: AppDispatch = useDispatch()

  const gridLayoutSetDefaultButtonId = `${
    gridName ?? ""
  }gridLayoutSetDefaultButton`
  const gridLayoutSaveButtonId = `${gridName ?? ""}gridLayoutSaveButton`
  const gridLayoutAllSetButtonId = `${gridName ?? ""}gridLayoutAllSetButton`
  const gridLayoutAllClearButtonId = `${gridName ?? ""}gridLayoutAllClearButton`

  //ポップアップの初期化
  const initSelectRowPopup = (popup: Popup) => {
    popup.owner = popoverButton.current
    setLayoutPopup(popup)
  }
  //pickerの初期化
  const initializedPicker = (component: TWijmoListBox) => {
    setColumnPicker(component)
  }

  const gridLayoutSetDefault = async () => {
    if (!flexGrid) return
    if (!userInfo?.社員ID) return

    await dispatch(画面ロック開始())
    const service = new SyainGridLayoutService()

    let newGridLayout = gridDefaultLayout

    try {
      const res = await service.getList({
        グリッドコード: gridName,
        パス: gridLayoutPath,
      })

      // 取得できた場合そのデータを用いてユーザーのグリッド情報を更新
      if (res.data.length > 0) {
        // 一件のみのため決め打ち
        newGridLayout = res.data[0].レイアウト
      } else {
        // 取得できなかった場合デフォルトのまま送信
        await service.post({
          パス: gridLayoutPath ?? "",
          グリッドコード: gridName ? gridName : "",
          社員ID: userInfo.社員ID,
          レイアウト: newGridLayout,
          ページサイズ: 0,
        })
      }
    } catch (error) {
      showWarningToast("レイアウトのサーバー保存に失敗しました。")
    } finally {
      // 保存された個別設定のローカルストレージ設定
      localStorage.setItem(
        thisGridLayoutKey,
        newGridLayout !== gridDefaultLayout ? newGridLayout : ""
      )

      // グリッドレイアウトの復元
      await flexGridHelper.applyGridLayout(
        flexGrid,
        newGridLayout,
        columnPicker
      )
      toastify.toast.dark(
        <>
          <FontAwesomeIcon
            icon={faSave}
            style={{ color: "#EEEEEE", marginRight: "1rem" }}></FontAwesomeIcon>
          <span>レイアウトを元に戻しました。</span>
        </>,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          transition: toastify.Slide,
        }
      )
      flexGrid.refresh()
      dispatch(画面ロック解除())
    }
  }

  const gridLayoutSetAll = async (isVisible: boolean) => {
    if (!columnPicker) return
    const columns = columnPicker.itemsSource as Column[]
    if (columns != null && columns.length > 0) {
      columnPicker.checkedItems = columns.filter(() => isVisible)
    }
    columnPicker.refresh()
  }

  const gridLayoutSave = async () => {
    if (!flexGrid) return
    if (!userInfo?.社員ID) return

    dispatch(画面ロック開始())
    localStorage.setItem(thisGridLayoutKey, flexGrid.columnLayout)
    toastify.toast.dark(
      <>
        <FontAwesomeIcon
          icon={faSave}
          style={{
            color: "#EEEEEE",
            marginRight: "1rem",
          }}></FontAwesomeIcon>
        <span>レイアウトを保存しました</span>
      </>,
      {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        transition: toastify.Slide,
      }
    )
    const ページサイズ = thisPageSizeLayoutKey
      ? localStorage[thisPageSizeLayoutKey]
      : undefined
    //APIに保存を実行
    try {
      await new SyainGridLayoutService().post({
        パス: gridLayoutPath ?? "",
        グリッドコード: gridName ? flexGrid.hostElement.id : "",
        社員ID: userInfo.社員ID,
        レイアウト: flexGrid.columnLayout,
        ページサイズ: ページサイズ ? parseInt(ページサイズ) : 0,
      })
    } catch (error) {
      showWarningToast("レイアウトのサーバー保存に失敗しました。")
    } finally {
      layoutPopup?.hide()
      dispatch(画面ロック解除())
    }
  }
  //flexGridを初期化後、最初のsetFlexGrid時のみに付与
  // データの更新のみでは動かないように
  useEffect(() => {
    if (flexGrid && !flexGridInitialized && columnPicker) {
      setFlexGridInitialized(true)
      // ポップアップのイベントリスナーがなぜか付けられないためここで登録
      document
        .getElementById(gridLayoutSetDefaultButtonId)
        ?.addEventListener("click", () => gridLayoutSetDefault())
      document
        .getElementById(gridLayoutSaveButtonId)
        ?.addEventListener("click", () => gridLayoutSave())

      document
        .getElementById(gridLayoutAllClearButtonId)
        ?.addEventListener("click", () => gridLayoutSetAll(false))

      document
        .getElementById(gridLayoutAllSetButtonId)
        ?.addEventListener("click", () => gridLayoutSetAll(true))
    }
  }, [flexGrid, flexGridInitialized, columnPicker])

  useEffect(() => {
    if (flexGrid && columnPicker) {
      const newColumnPicker = columnPicker
      newColumnPicker.itemsSource = flexGrid.columns
      newColumnPicker.checkedMemberPath = "visible"
      newColumnPicker.displayMemberPath = "header"
      setColumnPicker(newColumnPicker)
    }
  }, [columnPicker, flexGrid])

  return (
    <>
      <Button variant="pending" ref={popoverButton}>
        <FontAwesomeIcon icon={faTasks} />
        <span>表示列設定</span>
      </Button>
      <wjInput.Popup
        showTrigger="Click"
        hideTrigger="Blur"
        initialized={initSelectRowPopup}
        className="popover min-w-50rem">
        <div className="popover-content min-w-50rem" style={{ margin: "1rem" }}>
          <wjInput.ListBox
            className="column-picker"
            initialized={initializedPicker}
          />
          <div className="form-button text-end" style={{ marginTop: "1rem" }}>
            <Button variant="canceled" id={gridLayoutAllClearButtonId}>
              すべて非表示
            </Button>
            <Button variant="working" id={gridLayoutAllSetButtonId}>
              すべて表示
            </Button>
            <Button id={gridLayoutSaveButtonId}>
              <FontAwesomeIcon icon={faSave} />
              <span>レイアウトを保存</span>
            </Button>
            <Button variant="secondary" id={gridLayoutSetDefaultButtonId}>
              レイアウトをクリア
            </Button>
          </div>
        </div>
      </wjInput.Popup>
    </>
  )
}

export const setDefaultLayout = async (
  grid: FlexGrid,
  setGridDefaultLayout: React.Dispatch<React.SetStateAction<string>>,
  gridLayoutKey: string
) => {
  setGridDefaultLayout(grid.columnLayout)
  // グリッドの前回の表示を再現
  await flexGridHelper.gridInitializedRestoreLayout(grid, gridLayoutKey)
}
